"use strict";

import Question from "./Question";
import schemaElevator from "./_schemaElevator";

class Questions {

    readonly _ds: any;
    private _state: any;
    constructor(writeDs, rsvpData) {
        this._ds = writeDs;
        this.updateRsvpData(rsvpData);
    }

    updateRsvpData(rsvpData) {
        this._state = schemaElevator.elevateSchema(rsvpData);
    }

    indexOfQuestion(q) {
        return this.asSortedArray().findIndex(qi => {
            return q.id == qi.id;
        });
    }

    questionAtIndex(i) {
        if (i < 0) {
            return null;
        }

        const qs = this.asSortedArray();
        if (i >= qs.length) {
            return null;
        }

        return qs[i];
    }

    asSortedArray() {

        // const canMove = (parent, child) =>
        //   Boolean(parent && child && !parent.dependencies.filter(dep => dep.questionId === child.id).length);

        return Object.keys(this._state.customQuestions)
            .map(qId => new Question(this, qId))
            .sort((q1, q2) => q1.compare(q2))
            .map((question, index, list) => {
                // question.canMoveUp = canMove(question, list[index-1]);
                // question.canMoveDown = canMove(list[index+1], question);
                return question;
            });

    }

    getQuestionWithId (id) {
        return this.asSortedArray().find(q => q.id === id);
    }

    rootQuestionsAsSortedArray() {
        return this.asSortedArray()
          .filter(q => !q.dependencies.length);
    }

    dependentOnQuestion(parent) {
        return this.asSortedArray()
          .filter(q =>
            q.dependencies
              .reduce((res, d) => res || d.question.id === parent.id, false)
          );
    }

    /**
     * Mostly for debugging return a string description of this question.
     * @returns {string}
     */
    toString() {
        return `${
            this.asSortedArray().filter(q => q.isEnabled).map(q => q.toString()).join("\n")
            }\n\ndisabled: [${
            this.asSortedArray().filter(q => !q.isEnabled).map(q => q.id).join(", ")
            }]`;
    }

    _createNewQuestionWithSortKey(data, sortKey) {
        const rawCustomQuestion: any = {
            type: data.type.toString(),
            prefix: "question-",
            question: data.question || "",
            title: data.title || ""
        };
        if (data.type.isMultipleChoice()){
            rawCustomQuestion.choices = {
                custom1: {
                    display: {v: ""}
                },
                custom2: {
                    display: {v: ""}
                }
            };
        }
        return this._qCreateRawCustomQuestion(rawCustomQuestion)
            .then(ref => this._qWriteRawSortKey(ref.key, sortKey));
    }

    _qGetRawOverride(questionId) {
        if (questionId in this._state.overrides) {
            return this._state.overrides[questionId];
        }
    }

    _qWriteRawOverride(questionId, isEnabled, callback) {
        //Todo: In draft mode divert writes elsewhere
        this.__qWriteRawOverride(questionId, isEnabled, callback);
    }

    __qWriteRawOverride(questionId, isEnabled, callback) {
        return this._ds.writeRsvpQuestionOverride(questionId, isEnabled, callback);
    }

    _qGetRawSortKey(questionId) {
        if (questionId in this._state.sortKeys) {
            return this._state.sortKeys[questionId];
        }
    }

    _qWriteRawSortKey(questionId, sortKey, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this.__qWriteRawSortKey(questionId, sortKey, callback);
    }

    __qWriteRawSortKey(questionId, sortKey, callback?) {
        return this._ds.writeRsvpQuestionSortKey(questionId, sortKey, callback);
    }

    _qGetRawCustomQuestion(questionId) {
        if (questionId in this._state.customQuestions) {
            return this._state.customQuestions[questionId];
        }
    }

    _qWriteRawCustomQuestionProperty(questionId, propertyName, propertyValue, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this.__qWriteRawCustomQuestionProperty(questionId, propertyName, propertyValue, callback);
    }

    __qWriteRawCustomQuestionProperty(questionId, propertyName, propertyValue, callback?) {
        return this._ds.writeRsvpCustomQuestionProperty(questionId, propertyName, propertyValue, callback);
    }

    _qCreateRawCustomQuestion(customQuestion, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this.__qCreateRawCustomQuestion(customQuestion, callback);
    }

    __qCreateRawCustomQuestion(customQuestion, callback?) {
        return this._ds.createRsvpCustomQuestionsChild(customQuestion, callback);
    }

    _qWriteRawCustomQuestionChoice(qId, cId, data, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this.__qWriteRawCustomQuestionChoice(qId, cId, data, callback);
    }

    __qWriteRawCustomQuestionChoice(qId, cId, data, callback?) {
        return this._ds.writeRsvpCustomQuestionChoice(qId, cId, data, callback);
    }

    _qWriteRawCustomQuestionDependency(qId, dId, data, callback?) {
        //Todo: In draft mode divert writes elsewhere
        return this.__qWriteRawCustomQuestionDependency(qId, dId, data, callback);
    }

    __qWriteRawCustomQuestionDependency(qId, dId, data, callback?) {
        return this._ds.writeRsvpCustomQuestionDependency(qId, dId, data, callback);
    }

    _qCreateRawCustomQuestionDependency(qId, dependency) {
        //Todo: In draft mode divert writes elsewhere
        return this.__qCreateRawCustomQuestionDependency(qId, dependency);
    }

    __qCreateRawCustomQuestionDependency(qId, dependency) {
        return this._ds.createRsvpCustomQuestionDependenciesChild(qId, dependency, undefined);
    }

}

export default Questions;
